// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false
// };

export const environment = {
  production: false,
  apiUrl: 'https://tahaniflowers.live',
 // facebookAppId: '314930319788683'
 facebookAppId: "5053259398073862",
  encryptionKey : "54901fff1f11b4f81681d0fa7fc4e863",
  iv:"e16ce913a20dadb8",
  token :"C14PwvwO4jjejXPcphTF"
};




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
